import { takeLatest } from 'redux-saga/effects';
import * as types from '../../../consts/admin/chargesTypes';
import * as saga from './saga';

export default function* watchCharges() {
    yield takeLatest(types.GET_ALL_CHARGES_REQUEST, saga.getAllChargesRequestSaga);
    yield takeLatest(types.POST_CHARGE_REQUEST, saga.postChargeRequestSaga);
    yield takeLatest(types.PUT_CHARGE_REQUEST, saga.putChargeRequestSaga);
    yield takeLatest(types.DELETE_CHARGE_REQUEST, saga.deleteChargeRequestSaga);
}